import React from 'react';
import Select from 'antd/lib/select';
// APOLLO
import emailTemplatesQuery from 'ApolloClient/Queries/emailTemplates';
import { graphql } from 'react-apollo';

const Option = Select.Option;

class EmailTemplateDropdown extends React.PureComponent {
  render() {
    const { emailTemplates, loading } = this.props.emailTemplatesQuery;

    return (
      <Select
        labelInValue
        size="large"
        searchPlaceholder="Enter template name..."
        placeholder="Enter template name..."
        notFoundContent={null}
        filterOption={false}
        onChange={val => {
          let selection = emailTemplates.filter(item => item._id === val.key);
          this.props.onChange(selection[0]);
        }}
        style={{ width: '100%', fontSize: '16px' }}
      >
        {loading ? (
          <Option key={'1'} disabled>
            Loading...
          </Option>
        ) : (
          emailTemplates.map(d => <Option key={d._id}>{d.title}</Option>)
        )}
      </Select>
    );
  }
}

export default graphql(emailTemplatesQuery, { name: 'emailTemplatesQuery' })(EmailTemplateDropdown);



// WEBPACK FOOTER //
// ./src/components/inputs/EmailTemplateDropdown/index.js